export default {"src":"/uk/_next/static/media/trust-pilot-stars.612ecd2d.svg","height":35,"width":189,"blurWidth":0,"blurHeight":0};